import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// 1 CARD 20-20 — table teen1t20. dtobx-top: Player(dragon-box) / Tie / Dealer
// (tiger-box) / Pair. Back-only, odds bold. book-black hamesha (Player/Dealer
// flex-book me, Tie/Pair flex-odds me).
const BetTableTeen120 = memo(function BetTableTeen120({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const player = findByNat(sub, 'Player');
  const dealer = findByNat(sub, 'Dealer');
  const tie = findByNat(sub, 'Tie');
  const pair = findByNat(sub, 'Pair');

  const bp = bookOf(exposures, 'Player');
  const bd = bookOf(exposures, 'Dealer');
  const bt = bookOf(exposures, 'Tie');
  const bpr = bookOf(exposures, 'Pair');

  return (
    <div className="dtobx-top">
      <div
        className={`dragon-box${isSusp(player) ? ' suspended' : ''}`}
        onClick={isSusp(player) ? undefined : () => handleBet(player.sid, 'back', player.b, player)}
      >
        <div className="flex-book">
          <b>Player</b>
          {' '}
          <span className={`d-block ${bookCls(bp)}`}>{fmtBook(bp)}</span>
        </div>
        {' '}
        <div className="text-center flex-odds">
          <span className="d-block"><b>{player?.b || 0}</b></span>
        </div>
      </div>
      {' '}
      <div
        className={`tiebox${isSusp(tie) ? ' suspended' : ''}`}
        onClick={isSusp(tie) ? undefined : () => handleBet(tie.sid, 'back', tie.b, tie)}
      >
        <div><b>Tie</b></div>
        {' '}
        <div className="text-center flex-odds">
          <span className="d-block"><b>{tie?.b || 0}</b></span>
          {' '}
          <span className={`d-block ${bookCls(bt)}`}>{fmtBook(bt)}</span>
        </div>
      </div>
      {' '}
      <div
        className={`tiger-box${isSusp(dealer) ? ' suspended' : ''}`}
        onClick={isSusp(dealer) ? undefined : () => handleBet(dealer.sid, 'back', dealer.b, dealer)}
      >
        <div className="flex-book">
          <b>Dealer</b>
          {' '}
          <span className={`d-block ${bookCls(bd)}`}>{fmtBook(bd)}</span>
        </div>
        {' '}
        <div className="text-center flex-odds">
          <span className="d-block"><b>{dealer?.b || 0}</b></span>
        </div>
      </div>
      {' '}
      <div
        className={`pair-box${isSusp(pair) ? ' suspended' : ''}`}
        onClick={isSusp(pair) ? undefined : () => handleBet(pair.sid, 'back', pair.b, pair)}
      >
        <div><b>Pair</b></div>
        {' '}
        <div className="text-center flex-odds">
          <span className="d-block"><b>{pair?.b || 0}</b></span>
          {' '}
          <span className={`d-block ${bookCls(bpr)}`}>{fmtBook(bpr)}</span>
        </div>
      </div>
    </div>
  );
});

export default BetTableTeen120;
